import { BrowseCurrentPlanEntitlementsResponse } from '@aibees/shared/definition';
import { useBaseQuery } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';
import { ENTITLEMENTS_ENDPOINT_UM } from '@aibees/shared/workspace/constants/endpoints';

export function useBrowseCurrentPlanEntitlementsApi() {
  const wid = useWorkspace()?.id;

  // `wid` is in the key because the url embeds it, and gated on `enabled` so we
  // don't fire a request at `/…/undefined/…` before useWorkspace() resolves.
  return useBaseQuery<never, BrowseCurrentPlanEntitlementsResponse>(
    [useBrowseCurrentPlanEntitlementsApi.name, wid],
    {
      url: ENTITLEMENTS_ENDPOINT_UM.replace(':wid', String(wid)),
    },
    { enabled: !!wid }
  );
}
